export default __webpack_public_path__ + "static/media/icon-search.344cb947.svg";